import type { AccountDetailsField } from './types';

import type { CollapseItemWithTypedSection } from '.';

export const getSummarySection = (
  virtualAccountDetails: AccountDetailsField[],
  isError: boolean
): CollapseItemWithTypedSection => {
  return {
    key: 'summary',
    label: <div>Funds withdrawal</div>,
    children:
      virtualAccountDetails && !isError ? (
        <div className="px-2">
          {virtualAccountDetails.map((detail) => (
            <div
              key={detail.name}
              className="flex justify-between gap-4 border-b border-border-strong py-4 text-sm font-semibold last-of-type:border-0"
              data-testid={`account-details-funds-${detail.name.toLowerCase()}`}
            >
              <div>{detail.name}</div>
              <div>
                {detail.currencySymbol} {detail.amount}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="px-2 pb-4 text-sm">
          <p className="text-sm">
            We are unable to access account information.
          </p>
        </div>
      )
  };
};
